import ordersController from './ordersController'

export default ordersController



// WEBPACK FOOTER //
// ../src/controllers/ordersController/index.js